import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { filter, Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { DriftConfiguration } from '../models/configuration.interface';
import { Log } from '../models/prompt-log.interface';

@Injectable({
  providedIn: 'root'
})
export class S3Service {
  config: DriftConfiguration;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.config = {};

    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  getFiles(type: string, collection_id: string): Observable<Log[]> {
    const params = new HttpParams().set('collection_id', collection_id).set('type', type);
    return this.http.get<Log[]>(`${this.config.driftApi}/logs`, { params });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pollResult(filename: string): Observable<any> {
    // const mockResponse = {
    //   body: {
    //     complete: 'true',
    //     session_id: 'mock-session-123',
    //     collection_id: 'mock-collection-456',
    //     response: `This is a mock response for testing the fade-in animation. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. [1] Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. [2] Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`,
    //     source_documents: [],
    //     metrics: {},
    //     user: 'mock-user'
    //   }
    // };
    // return of(mockResponse);
    const requestBody = { filename };
    return this.http.post(`${this.config.driftApi}/poll-result`, requestBody, {
      observe: 'response'
    });
  }
}
